jQuery(document).ready(function ($) {

    var CW_theme_framework = (function () {

        var originalJs = function () {

            $('map area').each(function (index, element) {
                let res = $(this)[0].href.split("/");
                let newRes = res.slice(-1).pop();
                let state = newRes.substring(1);
                $(this).attr("title", state);
            });

            // Location .squares-grid fix removing <br> tags
            $('.squares-grid').find('> br').remove();

            $('input, textarea').on('focus', function () {
                if ($(this).attr('placeholder')) $(this).data('placeholder', $(this).attr('placeholder')).removeAttr('placeholder');
            }).on('blur', function () {
                if ($(this).data('placeholder')) $(this).attr('placeholder', $(this).data('placeholder')).removeData('placeholder');
            });

            //Skip Link
            var skipLink = function () {
                $(".skiplink").focusin(function () {
                    $(this).css("position", "static");
                });

                $(".skiplink").focusout(function () {
                    $(this).css("position", "absolute");
                });
            }

            /* FILE UPLOAD */
            if ( $( "#fileupload" ).length ) {
                var fi = $('#fileupload'); //file input 
                var process_url = '/wp-content/themes/cws-theme-work-mix/file-upload/upload.php'; //PHP script
                var progressBar = $('<div/>').addClass('progress').append($('<div/>').addClass('progress-bar')); //progress bar
                var uploadButton = $('<button/>').addClass('btn btn-submit').text('Upload');    //upload button
        
                uploadButton.on('click', function () {
                    var $this = $(this), data = $this.data();
                    event.preventDefault();
                    data.submit().always(function () {
                            $this.parent().find('.progress').show();
                            $this.parent().find('.remove').remove();
                            $this.remove();
                            
                    });
                });

                //initialize blueimp fileupload plugin
                fi.fileupload({
                    url: process_url,
                    dataType: 'json',
                    autoUpload: false,
                    acceptFileTypes: /(\.|\/)(pdf|word)$/i,
                    maxFileSize: 1048576, //1MB
                    dropZone: $('#dropzone')
                });
        
                fi.on('fileuploadadd', function (e, data) {
                        data.context = $('<div/>').addClass('file-wrapper').appendTo('#files');
                        $.each(data.files, function (index, file){  
                        var node = $('<div/>').addClass('file-row');
                        var removeBtn  = $('<button/>').addClass('btn btn--1 remove').text('Remove');
                        removeBtn.on('click', function(e, data){
                            $(this).parent().parent().remove();
                        });
                        
                        var file_txt = $('<div/>').addClass('file-row-text clearfix').append('<span>'+file.name + ' (' +format_size(file.size) + ')' + '</span>');
                        
                        file_txt.append(removeBtn);
                        file_txt.prependTo(node).append(uploadButton.clone(true).data(data));
                        progressBar.clone().appendTo(file_txt);
                        if (!index){
                            node.prepend(file.preview);
                        }
                        
                        node.appendTo(data.context);
                    });
                });

                fi.on('fileuploadprocessalways', function (e, data) {
                    var index = data.index,
                        file = data.files[index],
                        node = $(data.context.children()[index]);
                        if (file.preview) {
                            node .prepend(file.preview);
                        }
                        if (file.error) {
                            node.append($('<span class="text-danger"/>').text(file.error));
                        }
                        if (index + 1 === data.files.length) {
                            data.context.find('button.upload').prop('disabled', !!data.files.error);
                        }
                });
        
                fi.on('fileuploadprogress', function (e, data) {
                    var progress = parseInt(data.loaded / data.total * 100, 10);
                    if (data.context) {
                        data.context.each(function () {
                            $(this).find('.progress').attr('aria-valuenow', progress).children().first().css('width',progress + '%').text(progress + '%');
                        });
                    }
                });

                fi.on('fileuploaddone', function (e, data) {
                    $.each(data.result.files, function (index, file) {
                        if (file.url) {
                            var link = $('<a>') .attr('target', '_blank') .prop('href', file.url);
                            $(data.context.children()[index]).addClass('file-uploaded');
                            $(data.context.children()[index]).find('canvas').wrap(link);
                            $(data.context.children()[index]).find('.file-remove').hide(); 
                            var done = $('<span class="text-success"/>').text('Uploaded!');
                            $(data.context.children()[index]).append(done);
                        } else if (file.error) {
                            var error = $('<span class="text-danger"/>').text(file.error);
                            $(data.context.children()[index]).append(error);
                        }
                    });
                });
        
                fi.on('fileuploadfail', function (e, data) {
                 $('#error_output').html(data.jqXHR.responseText);
                });
        
                function format_size(bytes) {
                    if (typeof bytes !== 'number') {
                        return '';
                    }
                    if (bytes >= 1000000000) {
                        return (bytes / 1000000000).toFixed(2) + ' GB';
                    }
                    if (bytes >= 1000000) {
                        return (bytes / 1000000).toFixed(2) + ' MB';
                    }
                    return (bytes / 1000).toFixed(2) + ' KB';
                }
            }

            //No comments
            $("#commentform").addClass("noauto");

            //Hover for Desktop, click for mobile nav
            /*if ($(window).width() > 767) {
                $('.dropdown').on('mouseenter mouseleave click tap', function() {
                    $(this).toggleClass("open");
                });
            }*/

            // ===== Scroll to Top ==== 
            enquire.register("screen and (max-width: 767px)", {

                match: function () {
                    returnToTop();
                }
            });

        };

        var tableOfContents = function () {

            var ToC = '';

            var newLine, el, title, link;

            if ($(".toc-heading").length) {

                $(".toc-heading").each(function () {

                    el = $(this);
                    title = el.text();
                    link = "#" + el.attr("id");

                    newLine =
                        "<li>" +
                        "<a class='toc-link' href='" + link + "'>" +
                        title +
                        "</a>" +
                        "</li>";

                    ToC += newLine;

                });

                //console.log(ToC);

                //ToC += "</ul></div></div></div>";

                $(".toc-table ul").prepend(ToC);

                //$('.toc-table ul').smoothScroll();

                $(".toc-link:empty").each(function () {
                    $(this).parent().css({
                        display: 'none'
                    });
                });

                returnToTop();
            }

        };

        var sameHeight = function () {

            $(window).load(function () {
                $('.grid-attorney .attorney-item').matchHeight();
                $('.grid-videos .video-description').matchHeight();
                $('.grid-results .item').matchHeight();


                $('.violence_resources__item').matchHeight();
                $('.violence_resources__item img').matchHeight();

                $('.contact-sidebar .col-item .sidebar-widget').matchHeight();

            });


            enquire.register("screen and (min-width: 992px)", {
                setup: function () {
                    // Load in content via AJAX (just the once)
                },
                match: function () {

                    $(window).load(function () {

                        let ht = $('.secondary-content-part .col-right img').outerHeight();

                        $('.secondary-content-part .col-right').css({
                            height: ht - 30
                        });

                    });

                },
                unmatch: function () {

                }
            });

            enquire.register("screen and (min-width: 992px) and (max-width: 1199px)", {
                setup: function () {
                    // Load in content via AJAX (just the once)
                },
                match: function () {


                },
                unmatch: function () {

                }
            });
        };

        var scrollToSection = function () {

            var scroll = new SmoothScroll('a[href*="#"]:not(.cycloneslider-next):not(.cycloneslider-prev)', {
                // Selectors
                ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
                header: null, // Selector for fixed headers (must be a valid CSS selector)
                topOnEmptyHash: true, // Scroll to the top of the page for links with href="#"
                speed: 500, // Integer. Amount of time in milliseconds it should take to scroll 1000px
                speedAsDuration: false, // If true, use speed as the total duration of the scroll animation
                durationMax: null, // Integer. The maximum amount of time the scroll animation should take
                durationMin: null, // Integer. The minimum amount of time the scroll animation should take
                clip: true, // If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
                offset: 0,
                updateURL: false,
                popstate: false,
                // Easing
                easing: 'easeInOutCubic', // Easing pattern to use
                customEasing: function (time) {
                    // Function. Custom easing pattern
                    // If this is set to anything other than null, will override the easing option above

                    // return <your formulate with time as a multiplier>

                    // Example: easeInOut Quad
                    return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;
                }
            });

        };

        var requiredInput = function () {

            $('.input-required').on('focus', function () {
                if ($(this).parent().data('required') == 'required') {
                    $(this).parent().removeClass('required');
                }
            });

            $('.input-required').on('blur', function () {
                if ($(this).val() == '') {
                    $(this).parent().addClass('required');
                }
            });

        };

        var hoverMenu = function () {

            $(window).load(function () {

                function fnIsAppleMobile() {
                    if (navigator && navigator.userAgent && navigator.userAgent != null) {
                        var strUserAgent = navigator.userAgent.toLowerCase();
                        var arrMatches = strUserAgent.match(/(iphone|ipod|ipad)/);
                        if (arrMatches != null)
                            return true;
                    } // End if (navigator && navigator.userAgent)

                    return false;
                } // End Function fnIsAppleMobile

                var bIsAppleMobile = fnIsAppleMobile();

                enquire.register("screen and (min-width: 768px)", {
                    setup: function () {
                        // Load in content via AJAX (just the once)
                    },
                    match: function () {

                        if (!bIsAppleMobile) {

                            function toggleDropdown(e) {
                                const _d = $(e.target).closest('.dropdown'),
                                    _m = $('.dropdown-menu', _d);
                                setTimeout(function () {
                                    const shouldOpen = e.type !== 'click' && _d.is(':hover');
                                    _m.toggleClass('show', shouldOpen);
                                    _d.toggleClass('show', shouldOpen);
                                    $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
                                }, e.type === 'mouseleave' ? 150 : 0);
                            }

                            $('body').on('mouseenter mouseleave', '.dropdown', toggleDropdown).on('click', '.dropdown-menu a', toggleDropdown);

                        }

                    },
                    unmatch: function () {

                    }

                });

            });


            enquire.register("screen and (max-width: 767px)", {
                setup: function () {
                    // Load in content via AJAX (just the once)
                },
                match: function () {

                    $('#nav-mobile .nav-link.dropdown-toggle').on('click', function () {
                        $(this).next().slideToggle();
                    });

                },
                unmatch: function () {

                }

            });

        };

        var videoFixes = function () {
            if ($(".cw_video_single").length > 0) {
                $(".cw_video_single").attr("src", $(".cw_video_single").attr("src").replace("rel=", "rel=0"));
            }
        };

        var returnToTop = function () {
            $(window).scroll(function () {
                if ($(this).scrollTop() >= 600) {        // If page is scrolled more than 50px
                    $('.btn-back').fadeIn(200);    // Fade in the arrow
                } else {
                    $('.btn-back').fadeOut(200);   // Else fade out the arrow
                }
            });
        };

        var carousels = function () {

            var awards = $(".awards-wrap");

            awards.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 5,
                slidesToScroll: 1,
                appendArrows: '.custom-nav-awards',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });

            $('.awards-part .item').matchHeight();
            $('.awards-part .sameHeight').matchHeight();

            var testimonials = $('.testimonials-section-slider');

            testimonials.slick({
                dots: false,
                infinite: true,
                appendArrows: '.custom-nav-test',
                adaptiveHeight: true
            });

            var sidebar_results = $('.results-slider__sidebar .grid-results');

            sidebar_results.slick({
                dots: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendArrows: '.custom-nav-results',
            });


            enquire.register("screen and (max-width: 767px)", {
                setup: function () {
                    // Load in content via AJAX (just the once)
                },
                match: function () {

                    var results = $(".grid-results");

                    results.slick({
                        dots: false,
                        arrows: true,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        appendArrows: '.custom-nav-results',
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                            // You can unslick at a given breakpoint now by adding:
                            // settings: "unslick"
                            // instead of a settings object
                        ]
                    });

                    var videos = $(".grid-videos");
                    videos.slick({
                        dots: true,
                        arrows: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                    infinite: true,
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                            // You can unslick at a given breakpoint now by adding:
                            // settings: "unslick"
                            // instead of a settings object
                        ]
                    });

                },
                unmatch: function () {

                }

            });

        };

        return {

            init: function () {
                originalJs();
                tableOfContents();
                sameHeight();
                scrollToSection();
                requiredInput();
                hoverMenu();
                videoFixes();
                carousels();
            }

        }

    })();

    CW_theme_framework.init();

});